import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import { initialPanelTransactions } from './panel_transactions.initial';

const selectPanelTransactionsState = (state: RootState) =>
    state.panel_transactions ?? initialPanelTransactions;

export const selectPanelTransactionsItems = createSelector(
    selectPanelTransactionsState,
    (section) => section.items,
);

export const selectPanelTransactionsLoading = createSelector(
    selectPanelTransactionsState,
    (section) => section.loading,
);

export const selectPanelTransactionsError = createSelector(
    selectPanelTransactionsState,
    (section) => section.error,
);

export const selectPanelTransactionsTotal = createSelector(
    selectPanelTransactionsState,
    (section) => section.total,
);

export const selectPanelTransactionsSummary = createSelector(
    selectPanelTransactionsState,
    (section) => section.summary,
);

export const selectPanelTransactionsHistoryFrom = createSelector(
    selectPanelTransactionsState,
    (section) => section.historyAvailableFrom,
);

export const selectPanelTransactionsLoadedForKey = createSelector(
    selectPanelTransactionsState,
    (section) => section.loadedForKey,
);

/** Consulta vigente: alimenta los controles de filtro y el paginador. */
export const selectPanelTransactionsQuery = createSelector(
    selectPanelTransactionsState,
    (section) => ({
        page: section.page,
        pageSize: section.pageSize,
        scope: section.scope,
        customerEmail: section.customerEmail,
        transactionId: section.transactionId,
        paymentStatus: section.paymentStatus,
        paymentMethod: section.paymentMethod,
        yearMonth: section.yearMonth,
    }),
);
